"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledBackground_1 = __importDefault(require("./StyledBackground"));
const StyledBackgroundContainer_1 = __importDefault(require("./StyledBackgroundContainer"));
const StyledInnerContainer_1 = __importDefault(require("./StyledInnerContainer"));
const StyledHeader_1 = __importDefault(require("./StyledHeader"));
const StyledSubheader_1 = __importDefault(require("./StyledSubheader"));
const redoOrderTrackingHero_png_1 = __importDefault(require("assets/images/redoOrderTrackingHero.png"));
const HeroImage = (props) => {
    return (react_1.default.createElement(StyledBackgroundContainer_1.default, null,
        react_1.default.createElement(StyledBackground_1.default, null,
            react_1.default.createElement(StyledInnerContainer_1.default, null,
                react_1.default.createElement("img", { alt: 'Redo order tracking page', height: '600px', src: redoOrderTrackingHero_png_1.default, width: '540px' }),
                react_1.default.createElement(StyledHeader_1.default, { "aria-level": 1, role: 'heading' }, props.header),
                react_1.default.createElement(StyledSubheader_1.default, { "aria-level": 2, role: 'heading' }, props.subheader)))));
};
HeroImage.propTypes = {
    header: prop_types_1.default.string,
    subheader: prop_types_1.default.string
};
exports.default = HeroImage;
